import React from 'react';
import { Form } from 'react-bootstrap';
import { Tag } from '../tagsSlice';

interface TagFormProps {
  details: Tag;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const TagForm: React.FC<TagFormProps> = ({
  details,
  handleInputChange,
}) => (
  <Form.Group>
    <Form.Label>Tagin nimi</Form.Label>
    <Form.Control
      type="text"
      id="name"
      name="name"
      value={details?.name || ''}
      onChange={handleInputChange}
    />
  </Form.Group>
);
